import React from 'react';
import { Box } from '@mui/material';
import { partnerLogoFor } from './partnerLogos';

const SIZE_SX = {
  title: { height: 36, maxWidth: 92, flexShrink: 0 },
  card: { maxHeight: 44, maxWidth: 160 },
  header: { maxHeight: 80, maxWidth: 220 },
};

const PartnerLogo = ({ locationId, size = 'card', sx }) => {
  const logo = partnerLogoFor(locationId);
  if (!logo) return null;

  return (
    <Box
      component="img"
      src={logo.src}
      alt={logo.alt}
      sx={{
        display: 'block',
        objectFit: 'contain',
        objectPosition: 'left center',
        ...SIZE_SX[size],
        ...sx,
      }}
    />
  );
};

export default PartnerLogo;
